// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bA","message":"bB","header":"bC","subHeading":"bD","buttons":"bE","buttonWrapper":"bF","btn":"bG"};